import { Dialog } from '@mui/material';
import * as React from 'react';

import MuiStyles from './styles';
import { ConnectingModalProps } from './types';

export default function ConnectingModal(props: ConnectingModalProps) {
    const { connected } = props;

    const classes = MuiStyles(props);

    return (
        <Dialog
            disableEscapeKeyDown
            open={!connected}
        >
            <div className={classes.content}>
                <p className={classes.loader}>Loading...</p>
                <p>
                    Connecting to the server...
                </p>
            </div>
        </Dialog>
    );
}